import { ACTION_ANY } from '../request';

export class Role {
    /**
     * @param {string} name
     * @param {Role|null} [parent]
     */
    constructor(name, parent) {
        this.name = name;
        this.parent = parent;
        this.resources = [];
    }

    /**
     * @returns {string[]}
     */
    getResourceIds() {
        return this.resources.map((resource) => resource.name);
    }

    /**
     * @param {Resource} resource
     * @returns {Resource}
     */
    addResource(resource) {
        const existing = this.getResource(resource.name);

        if (existing) {
            return existing.merge(resource);
        }

        this.resources.push(resource);

        return resource;
    }

    /**
     * @param {string} name
     * @returns {Resource}
     */
    getResource(name) {
        return this.resources.find((resource) => resource.name === name);
    }

    /**
     * @param {AccessPermissionRequest} request Permission request descriptor
     * @param {boolean} [strict] Check only this role (no parent role checks)
     * @returns {boolean} True if granted
     */
    isGranted(request, strict = false) {
        let examine;
        const resource = this.getResource(request.resource);

        if (resource) {
            let granted;

            if (request.isAny()) {
                granted = resource.isGranted(ACTION_ANY);

                if (granted !== undefined) {
                    return granted;
                }
            } else {
                examine = new Set(request.actions);

                for (const action of request.actions) {
                    const got = resource.isGranted(action);

                    if (got === false) {
                        return false;
                    }

                    if (got === true) {
                        examine.delete(action);
                    }
                }

                if (examine.size) {
                    request = request.only([...examine]);
                } else {
                    return true;
                }
            }
        }

        return (!strict && this.parent && this.parent.isGranted(request)) || false;
    }
}
